export const EMAIL_PROVIDERS = [
  {
    label: "SendGrid",
    value: "sendgrid",
  },
];
